<template>
    <div class="af" >
        <div class="flex alc" id="toolH">
           <!-- <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    clearable
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" placeholder="请输入订单号/销售单号/品名搜索" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>-->
            <el-button v-if="!isred" class="marr4" style="font-size: 14px;padding: 8px 15px 5px 0px;" type="text"  size="mini" @click="openzt()">{{$t('invoiceEntry_add_expense_sheet')}}+</el-button>
            <el-button v-if="isred" class="marr4" style="font-size: 14px" type="text"  size="mini" @click="openzt(3)">{{$t('invoiceEntry_add_associated_rebate_products')}}+</el-button>
            <span class="marr4">{{$t('invoiceEntry_total_invoice_amount')+fppay}}</span>
            <span :class="choopay!=fppay?'blue marr4':'marr4'">{{$t('invoiceEntry_selected_amount')+':'+choopay}}</span>
        </div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="currentPageData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                :height="tableHeight"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @select="select"
                @select-all="selectAll"
                :row-key="row => row.i_pzid"
                :default-selection="defaultSelectedRows"
        >
            <el-table-column
                    v-if="i_checkstate==0"
                    align="center"
                    type="selection"
                    :selectable="isRowSelectable"
                    :reserve-selection="true">
            </el-table-column>
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="i_order_pid"
                    :label="$t('invoiceEntry_cost_id')"
                    show-overflow-tooltip
                    width="95">
            </el-table-column>
            <el-table-column
                    prop="vc_no"
                    :label="$t('form_order_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    v-if="!isred"
                    prop="vc_code"
                    :label="$t('invoiceEntry_document_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    :label="$t('invoiceEntry_sales_order_number')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.vc_pzname}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    v-if="!isred"
                    align="right"
                    prop="f_fynum"
                    :label="$t('invoiceEntry_quantity_of_expenses')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    v-if="!isred"
                    align="right"
                    prop="f_yfee_yj"
                    :label="$t('invoiceEntry_estimated_amount')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    v-if="!isred"
                    align="right"
                    prop="f_fyje"
                    :label="$t('invoiceEntry_amount_of_fee')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    align="right"
                    prop="f_kglfpnum"
                    label="可关联发票数量"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    align="right"
                    prop="f_kglfpje"
                    :label="$t('invoiceEntry_can_be_associated_with_invoice_amount')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    align="right"
                    prop="f_je"
                    :label="$t('invoiceEntry_this_associated_invoice_amount')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-input-number disabled @change="inbcfnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_je" ></el-input-number>
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="dt_createtime"
                    :label="$t('form_creation_time')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    align="right"
                    prop="f_je_ws"
                    :label="$t('invoiceEntry_tax-excluded_amount_on_the_invoice')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_sl"
                    :label="$t('form_tax_rate')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_je_zzs"
                    :label="$t('invoiceEntry_tax_amount')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column  align="center"  width="50" >
                <template  slot-scope="scope" >
                    <div class="iconminus">
                        <span class="minus"  @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[500, 1000, 1500]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableData.length">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button  v-if="i_checkstate==0" type="primary" @click="confirm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="5vh"
                width="85%"
                :title="$t('invoiceEntry_list')"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="handleConfirmzt([],[])"
                v-if="dialogVisible"
                :append-to-body="true">
<!--            <add-clist v-if="!isred" :dataZt="dataZt" :dataOrd="dataOrd" ref="dialogB" @confirmzt="handleConfirmzt"></add-clist>-->
<!--            <addcg-llist v-else :dataZt="dataZt" :dataOrd="dataOrd" ref="dialogB" @confirmzt="handleConfirmzt"></addcg-llist>-->
            <addpz-list :dataZt="dataZt" :dataOrd="dataOrd" ref="dialogB" @confirmzt="handleConfirmzt"></addpz-list>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    //import addClist from "./addClist";
    //import addcgLlist from "./addcgLlist";
    import addpzList from "./addpzList";
    export default {
        name: "",
        components: {
            //addClist,addcgLlist,
            addpzList,
        },
        props: {
            dataOrd: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                maxDialogHeight:0,
                dataZt:{},
                deletedDataIds:[],
                dialogVisible:false,
                tableHeight: 400,
                loading:false,
                dt_startdate:'',
                dt_enddate:'',
                vc_search:"",
                valuetime:'',
                baseerp: "",
                mid: 0,
                expend:false,
                showTable:true,
                tableData: [],
                multipleSelection: [],
                pageSize: 500,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
                currentInvoiceId: null,
                fppay:0,
                choopay:0,
                i_checkstate:0,
                isred:false,
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        computed: {
            defaultSelectedRows() {
                // 返回当前选中的数据用于 default-selection
                return this.multipleSelection;
            },
            currentPageData(){
                const start = (this.currentPage -1 )*this.pageSize;
                const end = this.currentPage*this.pageSize;
                return this.tableData.slice(start,end);
            }
        },
        watch: {
            dataOrd: {
                handler() {
                    //console.log("dataOrd", this.dataOrd);
                    this.isred=this.dataOrd.isred;
                    //this.getfMou();
                    //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
                    //console.log("dataOrd", this.dataOrd);
                    //console.log("this.tableData", this.tableData);
                    //this.tableTotal=this.dataOrd.row.details.length;
                    //this.currentInvoiceId = this.dataOrd.index;
                    this.currentInvoiceId = this.dataOrd.row.localId;
                    this.i_checkstate=this.dataOrd.i_checkstate;
                    let fppay=this.dataOrd.row.f_pay_ws+this.dataOrd.row.f_pay_zzs;
                    this.fppay=this.keepTwoDecimal(fppay);
                    //console.log(this.fppay,'this.fppay');
                //    if(this.isred){
                //        this.tableData=[];
                //        this.getOrders(3)
                //    }else{
                        this.tableData=this.deepClone(this.dataOrd.row.details);
                        this.$nextTick(() => {
                            const table = this.$refs.table;
                            if (table) {
                                this.tableData.forEach(row => {
                                    const isSelected = this.dataOrd.row.details.some(sel => sel.uniqueKey == row.uniqueKey);
                                    table.toggleRowSelection(row, isSelected);
                                    if(isSelected){
                                        this.multipleSelection.push(row);
                                        //console.log(this.multipleSelection,'this.multipleSelection');
                                        this.changeselT()
                                    }
                                });
                            }
                            this.updateTableHeight();
                            window.addEventListener('resize', this.updateTableHeight);
                        });
                //    }
                },
                immediate: true,
                deep: true
            },
        },
        mounted() {
            /*//this.getfMou();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("dataOrd", this.dataOrd);
            this.tableData=this.deepClone(this.dataOrd.row.details);
            //console.log("this.tableData", this.tableData);
            //this.tableTotal=this.dataOrd.row.details.length;
            this.currentInvoiceId = this.dataOrd.index;
            this.i_checkstate=this.dataOrd.i_checkstate;
            let fppay=this.dataOrd.row.f_pay_ws+this.dataOrd.row.f_pay_zzs;
            this.fppay=this.keepTwoDecimal(fppay);
            //console.log(this.fppay,'this.fppay');
            this.$nextTick(() => {
                const table = this.$refs.table;
                if (table) {
                    this.tableData.forEach(row => {
                        const isSelected = this.dataOrd.row.details.some(sel => sel.uniqueKey == row.uniqueKey);
                        table.toggleRowSelection(row, isSelected);
                        if(isSelected){
                            this.multipleSelection.push(row);
                            //console.log(this.multipleSelection,'this.multipleSelection');
                            this.changeselT()
                        }
                    });
                }
                this.updateTableHeight();
                window.addEventListener('resize', this.updateTableHeight);
            });*/
            //this.getOrders();
            this.baseerp = baseerp;
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods: {
            updateTableHeight() {
                //console.log(this.dataOrd.maxDialogHeight,'this.dataOrd.maxDialogHeight');
                const dialogHeight = this.dataOrd.maxDialogHeight * 0.9; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight = 300;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight=this.dataOrd.maxDialogHeight;
            },
            deleteRow(value, index) {
                const islossrelate = this.multipleSelection.find(item => item.i_pzid === value.i_pzid);
                const idx = this.multipleSelection.findIndex(item => item.i_pzid === value.i_pzid);
                if (islossrelate) {
                    this.$refs.table.toggleRowSelection(islossrelate, false);
                    this.multipleSelection.splice(idx,1)
                    if(value.i_id!=0){
                        this.deletedDataIds.push(value.i_id);
                    }
                    this.tableData.splice(index, 1);
                    this.changeselT();
                }
                //this.tableTotal=this.tableData.length;
            },
            openzt(type) {
                let remain = this.keepTwoDecimal(this.fppay - this.choopay)
                this.dataZt={
                    type:type,
                    remain:remain,
                    select:this.multipleSelection,
                    del:this.deletedDataIds,
                }
                this.dialogVisible=true;
            },

            handleConfirmzt(selectedRows,deletedIds) {
                this.dialogVisible=false;
                // if (selectedRows.type == 'back') {
                // } else {
                deletedIds.forEach(id => {
                    const index = this.tableData.findIndex(item => item.i_id === id);
                    if (index !== -1) {
                        //this.deletedDataIds.push(this.tableData[index].i_pzid);
                        this.tableData.splice(index, 1);
                    }
                });
                this.deletedDataIds=[...new Set([...this.deletedDataIds, ...deletedIds])];
                //console.log(this.deletedDataIds,'this.deletedDataIds');
                //console.log('最终确认勾选数据:', selectedRows)
                this.multipleSelection=[];
                //let Data=[...selectedRows,...this.tableData];
                let Data=selectedRows.length==0?[...selectedRows,...this.tableData]:[...selectedRows];
                this.tableData = Data.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.i_pzid === value.i_pzid
                    ))
                );
                this.$nextTick(() => {
                    const table = this.$refs.table;
                    if (table) {
                        this.tableData.forEach(row => {
                            //const isSelected = this.multipleSelection.some(sel => sel.i_id == row.i_id);
                            table.toggleRowSelection(row, true);
                            //if(!isSelected){
                            this.multipleSelection.push(row);
                            //console.log(this.multipleSelection,'this.multipleSelection');
                            this.changeselT()
                            //}
                        });
                        //this.tableTotal=this.tableData.length;
                        this.currentPage=1;
                    }
                });
                // }

            },
            inbcfnum(data,index,row){
                if(row.f_je <= 0){
                    row.f_je = row.f_kglfpje;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_amount_cannot_be_less_than_or_equal_to_0'));
                    this.refreshTable();
                    return;
                }
                if(row.f_je > row.f_kglfpje){
                    row.f_je = row.f_kglfpje;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_amount_of_this_associated_invoice_cannot_exceed_the_amount_of_the_invoice_that_can_be_associated'));
                    this.refreshTable();
                    return;
                }
                this.$set(data,index,row);
                this.changeselT();
                /*console.log(this.tableData,this.multipleSelection,'sss')
                const idx = this.multipleSelection.findIndex(sel => sel.i_order_pid === row.i_order_pid);
                if (idx !== -1) {
                    this.multipleSelection[idx].f_je = row.f_je;
                }*/
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                /*this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })*/

                this.currentPage=1;
                this.tableData=[];
                this.getOrders();
            },

            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                    this.restoreSelection();
                })
            },
            restoreSelection() {
                this.$nextTick(() => {
                    this.multipleSelection.forEach(selectedRow => {
                        const matched = this.tableData.find(item => item.i_order_pid === selectedRow.i_order_pid);
                        if (matched) {
                            this.$refs.table.toggleRowSelection(matched, true);
                        }
                    });
                });
            },
            isRowSelectable(row,index){
               /*if(row.disabled){
                   return false
               }else{
                   return true
               }*/
            },
            selectAll(val){
                val.forEach(item => item.f_je=item.f_kglfpje);
                this.multipleSelection = val;
                //console.log(this.multipleSelection,'val-all')
                this.changeselT();
            },
            select(val,row){
                const isSelected = val.some(item => item.i_order_pid === row.i_order_pid);
                if(isSelected){
                    row.f_je=row.f_kglfpje;
                    this.multipleSelection = val;
                    //console.log(this.multipleSelection,'val')
                }else{
                    row.f_je=0;
                    this.multipleSelection = val;
                    //console.log(this.multipleSelection,'val')
                }
                this.changeselT();
            },
            changeselT(){
                let total=0;
                this.multipleSelection.forEach(item=>{
                    total += item.f_je
                })
                this.choopay = this.keepTwoDecimal(total);
            },
            // 查询费用列表
            async getOrders(){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    //'i_id':this.dataOrd.i_id,
                    'i_id':this.dataOrd.i_glfpid,
                    'i_kpkhid':this.dataOrd.i_kpkhid,
                    'i_gsid':this.dataOrd.i_gsid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_fymx':this.dataOrd.vc_fymx,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    'vc_search':this.vc_search,
                    'i_checkstate':this.dataOrd.i_checkstate,
                    'i_redInvoiceId':this.dataOrd.i_id,
                    'isAdd':0,
                    'inoiceType':2,
                };
                let res = await API.getRedInvoiceDetail(param);//  fksq
                if (res.code == 1) {
                    this.loading=false;
                    if(this.dataOrd.row.details.length==0){
                        this.tableData=[];
                    }else{
                        this.tableData=this.deepClone(res.data);
                    }
                    this.tableTotal = res.data.total;
                    //console.log(this.tableData);
                    this.$nextTick(() => {
                        const table = this.$refs.table;
                        if (table) {
                            this.tableData.forEach(row => {
                                row.f_je=row.f_je==0?row.f_kglfpje:row.f_je;
                                const isSelected = this.dataOrd.row.details.some(sel => sel.i_order_pid == row.i_order_pid);
                                const idx = this.dataOrd.row.details.findIndex(sel => sel.i_order_pid === row.i_order_pid);
                                table.toggleRowSelection(row, isSelected);
                                if(isSelected){
                                    //console.log(isSelected)
                                    row.f_je=this.dataOrd.row.details[idx].f_je
                                    this.multipleSelection.push(row);
                                    //console.log(this.multipleSelection,'this.multipleSelection');
                                }
                            });
                            this.changeselT();

                        }
                    });
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                //this.getOrders();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                //this.getOrders();
            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getOrders();
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.getOrders();
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            confirm() {
                //console.log(this.multipleSelection,'this.multipleSelection')
                if(this.multipleSelection.length==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_cost'));
                    return
                }
                let total=0;
                let ids = [];
                this.multipleSelection.forEach(item=>{
                    ids.push(item.i_order_pid)
                    item.f_sl=this.dataOrd.row.f_sl
                    total += item.f_je
                })
                total=this.keepTwoDecimal(total);
                //console.log('total',total);
                //console.log('f_pay',this.fppay);
                /*if(total!=this.fppay){
                    this.$message.error(this.$t('invoiceEntry_the_total_amount_of_this_associated_invoice_must_be_consistent_with_the_invoice_inclusive_of_taxes'));
                    return
                }*/
                if(Math.abs(total)>Math.abs(this.fppay)){
                    this.$message.error(this.$t('invoiceEntry_the_total_amount_of_this_associated_invoice_cannot_exceed_the_invoice_inclusive_tax_amount'));
                    return
                }
                //console.log(this.multipleSelection,'this.multipleSelection')
                this.$emit('confirm', {
                    invoiceId: this.currentInvoiceId,
                    selections: JSON.parse(JSON.stringify(this.multipleSelection)),
                    ids:ids,
                    dels:this.deletedDataIds,
                    choopay:total,
                });
            },
            cancel(){
                this.$emit('confirm',{type:'back'});
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    /* 隐藏 el-table 的全选框 */
    /deep/ .el-table__header-wrapper th .cell .el-checkbox {
        display: none;
    }
    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
